export default {
  startGame: 'startGame',
  removeMultitask: 'removeMultitask',
  selectCriticalChain: 'selectCriticalChain',
  defineBufferSize: 'defineBufferSize',
  previousStep: 'previousStep',
}
